import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { Swiper, SwiperSlide } from "swiper/react";
import { CustomPopup, LoadingBox, Popup } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { ChkBox, CustomSelect, InputBoxCol2, InputCaption, InputItemBox } from "component/basic/formItems";
import { comFormat, getDateGap, paymentFailedCode } from "js/function";
import { CarDetailItem } from "component/product/car";
import { FixedPage, FixedSection, PopupContentsTitle } from "component/basic";
import { ChkSelect } from "component/basic/tap";
import { BaiscPopupTextBox, CarDetailControllBox, CarDetailSection, CarDetailTextArea, CarSetInfoCaption, CarSetInfoItem, CarSetInfoSection, CarSetInfoSlideSection, CarSetTermsItem, FixedContents, PaymentCardBtnBox, PaymentTypeBtn, PaymentTypeBtnBox } from "component/product/page";
import { CardAddBtn, CardItem, CardSlideControll } from "component/product/card";

const RentPayment = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const type = param.type;

    const location = useLocation();
	const locationData = location?.state ? location?.state : null;
    const paymentDataLoca = locationData?.paymentData;
    const carData = locationData?.carData;
    const addTotalPriceSel = locationData?.addTotalPriceSel;
    const insuranceSel = locationData?.insuranceSel;
    const memberCode = locationData?.memberCode;
    
    const reservationData = locationData?.reservationData;

    const rentDay = type === "edit" ? 
                    reservationData?.start_date && reservationData?.end_date ? getDateGap(reservationData?.start_date,reservationData?.end_date,"day") : 0
                    : paymentDataLoca ? getDateGap(paymentDataLoca?.start_date,paymentDataLoca?.end_date,"day") : 0;
    const rentDayPayment = type === "edit" ? paymentDataLoca?.start_date && paymentDataLoca?.end_date ? getDateGap(paymentDataLoca?.start_date,paymentDataLoca?.end_date,"day") : null : null;
    
    const [popupData,setPopupData] =  useState(null);
    const [paymentFailedData,setPaymentFailedData] =  useState(null);

    const [totalPrice,setTotalPrice] =  useState(0);
    const [totalSalePrice,setTotalSalePrice] =  useState(0);
    const [totalCouponPrice,setTotalCouponPrice] =  useState(0);
    const [totalAddTotalPrice,setTotalAddTotalPrice] =  useState((type === "edit" ? paymentDataLoca?.add_productChk ? addTotalPriceSel : (Number(reservationData?.add_product_price) / rentDay * (rentDayPayment ? rentDayPayment : rentDay)) : addTotalPriceSel)||0);

    const [cardBtnChk,setCardBtnChk] =  useState(true);
    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);
    const [settingChk,setSettingChk] =  useState(false);

    const [paymentData,setPaymentData] = useState({
        payment_method:"billing",
        coupon:null,
        use_point:0,
        user_card_id:null
    });

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(false);
    const [cardAddPopup,setCardAddPopup] =  useState(null);

    const [card_type,setCard_type] =  useState("1");
    const [card_no,setCard_no] =  useState(null);
    const [exp_year,setExp_year] =  useState(null);
    const [exp_month,setExp_month] =  useState(null);
    const [birth,setBirth] =  useState(null);
    const [card_pw,setCard_pw] =  useState(null);
    const [is_chk,setIs_chk] =  useState(0);

    const [cardApiUpdate,setCardApiUpdate] =  useState(0);
    const cardApi = useGet({
        url:localStorage.getItem("token") ? `/card?update=${cardApiUpdate}` : null,
        loginType:"login"
    });
    const cardApiData = cardApi?.data?.user_card;
    
    const couponApi = useGet({
           url:localStorage.getItem("token") ? `/coupon?status=1&is_rent=1${type === "edit" ? `&reservation_id=${reservationData?.id}` : ""}` : null,
           loginType:"login"
    });
    const couponData = couponApi?.data?.coupons;
    const [couponItems,setCouponItems] =  useState([]);

    const pointApi = useGet({
        url:localStorage.getItem("token") ? `/point/history?type=1` : null,
        loginType:"login"
    });
    const total_point = type === "edit" ? Number(pointApi?.data?.total_point) + Number(reservationData?.use_point||0) : pointApi?.data?.total_point;

    const [maxPoint,setMaxPoint] =  useState(total_point||0);

    function cardDataReset(){
        setCard_type("1");
        setCard_no(null);
        setExp_year(null);
        setExp_month(null);
        setBirth(null);
        setCard_pw(null);
        setIs_chk(0);
    }
    
    function cardDel(id){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);

            fatchSet.FatchApi({
                type:"DELETE",
                loginType: "login",
                url: `/card/delete?user_card_id=${id}`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);

                    window.errPopupOpen({
                        alert:"카드 삭제 완료",
                        data:"선택하신 카드 삭제가 완료되었습니다.",
                        closeType:true,
                        func:()=>{}
                    });

                    setCardApiUpdate(cardApiUpdate + 1);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    function cardAdd(){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);

            let formData = new FormData();

            formData.append("card_type", card_type);
            formData.append("card_no", card_no?.replace(/-/g,""));
            formData.append("exp_year", exp_year);
            formData.append("exp_month", exp_month);
            formData.append("birth", birth?.replace(/-/g,""));
            formData.append("card_pw", card_pw);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/card/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);

                    window.errPopupOpen({
                        alert:"카드 등록 완료",
                        data:"입력하신 카드 정보로 등록이 완료되었습니다.",
                        closeType:true,
                        func:()=>{}
                    });

                    setCardApiUpdate(cardApiUpdate + 1);
                    
                    setCardAddPopup(null);
                    cardDataReset();
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    function paymentFunc(){
        if(submitChk){
            if (window.wcs) {
                if (!window.wcs_add) window.wcs_add = {};

                window.wcs_add["wa"] = process.env.REACT_APP_NAVER_ANALYTIC_ID;

                var _conv = {};
                _conv.type = 'begin_checkout';
                _conv.items = [{
                    id: locationData?.carData?.id,
                    name: locationData?.carData?.name,
                    payAmount: totalPrice
                }];
                window.wcs.trans(_conv);
            }

            setSubmitChk(false);
            setLoadingBoxOpen(true);

            let formData = new FormData();

            if(type === "edit"){
                formData.append("reservation_id", paymentDataLoca?.reservation_id);
            }

            if(type === "edit" && paymentDataLoca?.cCode){
                formData.append("company_mapped_code", paymentDataLoca?.cCode);
            }else if(type !== "edit"){
                formData.append("company_mapped_code", paymentDataLoca?.company_mapped_code);
            }

            if(type === "edit" && paymentDataLoca?.mCode){
                formData.append("model_mapped_code", paymentDataLoca?.mCode);
            }else if(type !== "edit"){
                formData.append("model_mapped_code", paymentDataLoca?.model_mapped_code);
            }

            formData.append("start_date", type === "edit" ? paymentDataLoca?.start_date ? paymentDataLoca?.start_date : reservationData?.start_date : paymentDataLoca?.start_date);
            formData.append("end_date", type === "edit" ? paymentDataLoca?.end_date ? paymentDataLoca?.end_date : reservationData?.end_date : paymentDataLoca?.end_date);

            if(type !== "edit"){
                formData.append("reservation_name", paymentDataLoca?.reservation_name);
                formData.append("reservation_phone", paymentDataLoca?.reservation_phone);
                formData.append("reservation_email", paymentDataLoca?.reservation_email);
                formData.append("reservation_birth", paymentDataLoca?.birthday);

                formData.append("driver_name", paymentDataLoca?.driver_name);
                formData.append("driver_birth", paymentDataLoca?.driver_birth);
                formData.append("driver_phone", paymentDataLoca?.driver_phone);
                formData.append("driver_license", paymentDataLoca?.driver_license);
                formData.append("driver_career", paymentDataLoca?.driver_career);
            }

            formData.append("insurance_id", type === "edit" ? paymentDataLoca?.reservationData && carData ? paymentDataLoca?.insurance_id : reservationData?.insurance_id : paymentDataLoca?.insurance_id);

            if(type === "edit"){
                if(paymentDataLoca?.add_product?.length > 0 || paymentDataLoca?.add_productChk){
                    paymentDataLoca?.add_product && paymentDataLoca?.add_product?.forEach(function(item,i){
                        formData.append("add_product_ids[]", item?.id);
                        formData.append("add_product_amounts[]", item?.qty);
                    });
                }else if(reservationData?.add_products){
                    reservationData?.add_products && reservationData?.add_products?.forEach(function(item,i){
                        formData.append("add_product_ids[]", item?.id);
                        formData.append("add_product_amounts[]", item?.amount);
                    });
                }
            }else{
                paymentDataLoca?.add_product && paymentDataLoca?.add_product?.forEach(function(item,i){
                    formData.append("add_product_ids[]", item?.id);
                    formData.append("add_product_amounts[]", item?.qty);
                });
            }

            if(!localStorage.getItem("token")){
                formData.append("phone", memberCode?.phone);
                formData.append("code", memberCode?.code);
            }

            formData.append("payment_method", totalPrice > 0 ? paymentData?.payment_method : "point");

            if(paymentData?.coupon){
                formData.append("coupon_id", paymentData?.coupon?.id);
            }

            if(paymentData?.use_point){
                formData.append("use_point", paymentData?.use_point);
            }

            if(paymentData?.payment_method === "billing" && totalPrice > 0){
                formData.append("user_card_id", paymentData?.user_card_id);
            }

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: localStorage.getItem("token") ? "login" : null,
                url: type === "edit" ? `/reservation/modify` : `/reservation/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);

                    if(totalPrice === 0 || paymentData?.payment_method === "billing"){
                        if (window.wcs) {
                            if (!window.wcs_add) window.wcs_add = {};

                            window.wcs_add["wa"] = process.env.REACT_APP_NAVER_ANALYTIC_ID;
                            var _conv = {};
                            _conv.type = 'schedule';
                            window.wcs.trans(_conv);
                        }

                        navigate(`/reservation/detail/${apiData?.data?.reservation_id}`,{state: {pageType:"payment",memberCode:memberCode}});
                    }else{
                        sessionStorage.setItem("paymentUrl",window.location.pathname);
                        
                        sessionStorage.setItem("paymentDataLoca",JSON.stringify(paymentDataLoca));
                        sessionStorage.setItem("carData",JSON.stringify(carData));
                        sessionStorage.setItem("addTotalPriceSel",addTotalPriceSel);
                        sessionStorage.setItem("insuranceSel",JSON.stringify(insuranceSel));
                        sessionStorage.setItem("reservationData",JSON.stringify(reservationData));
                        sessionStorage.setItem("memberCode",JSON.stringify(memberCode));

                        window.location.href = type === "edit" ? `${process.env.REACT_APP_API}/reservation/modify/payment?id=${apiData?.data?.reservation_id}&access_token=${localStorage.getItem("token") ? localStorage.getItem("token") : ''}` : `${process.env.REACT_APP_API}/reservation/payment?id=${apiData?.data?.reservation_id}&access_token=${localStorage.getItem("token") ? localStorage.getItem("token") : ''}`;
                    }
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        setPaymentFailedData({
                            addClass:null,
                            title:"결제 실패",
                            text:"결제가 실패하였습니다.<br/>설정하신 조건으로 대여 가능한 차량을 다시 불러올게요.",
                            closeType:true,
                            closeFunc:(e) => {setPaymentFailedData(null)},
                            btnFunc0:(e)=>{
                                setPaymentFailedData(null);
                                navigate("/rent/list",{state: {
                                    filterData:{
                                        addr:"제주국제공항",
                                        startDtm: (type === "edit" ? paymentDataLoca?.start_date ? paymentDataLoca?.start_date : reservationData?.start_date : paymentDataLoca?.start_date)||null,
                                        endDtm: (type === "edit" ? paymentDataLoca?.end_date ? paymentDataLoca?.end_date : reservationData?.end_date : paymentDataLoca?.end_date)||null,
                                        birth:null,
                                        career:null,
                                        carCategory:[],
                                        insuranceId:(type === "edit" ? paymentDataLoca?.reservationData && carData ? paymentDataLoca?.insurance_id : reservationData?.insurance_id : paymentDataLoca?.insurance_id)||null,
                                        insuranceName:(type === "edit" ? paymentDataLoca?.reservationData && carData ? paymentDataLoca?.insurance_name : reservationData?.insurance_name : insuranceSel?.name)||null
                                    }
                                }});
                            },
                            btn0:"차량 리스트 보기",
                            btn0Type:"",
                            btn1:null,
                            btn1Type:"",
                            btnFunc1:()=>{},
                            alert:paymentFailedCode(apiData?.alert)
                        });
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    function paymentDataCh(key,val){
        let oldData = {...paymentData};
        oldData[key] = val;
        setPaymentData(oldData);
    }

    useEffect(() => {
        sessionStorage.clear();
        setSettingChk(true);

        if(!(paymentDataLoca)){
            navigate("/pageErr");
        }
    }, []);


    useEffect(() => {
        let setData = [];

        if(couponData){
            let oldData = [...couponData];
            
            if(oldData?.length > 0){
                oldData?.forEach(function(item,i){

                    setData.push({
                        ...item,
                        disabled: item?.use_condition === "min_price" ? item?.use_condition_value <= (totalPrice + totalSalePrice) ? false : true : false
                    });

                    if(oldData?.length - 1 == i){
                        setCouponItems(setData);
                    }
                })
            }else{
                setCouponItems(setData);
            }
        }else{
            setCouponItems(setData);
        }

        if(paymentData?.coupon && paymentData?.coupon?.use_condition === "min_price" ? paymentData?.coupon?.use_condition_value <= (totalPrice + totalSalePrice) ? false : true : false){
            paymentDataCh("coupon",null);
        }
    }, [couponApi,totalPrice,totalSalePrice]);

    useEffect(() => {
        if(cardApiData && localStorage.getItem("token")){
            paymentDataCh("user_card_id",cardApiData[0]?.id);
        }
    }, [cardApi]);

    useEffect(() => {
        if(!addTotalPriceSel && paymentDataLoca && paymentDataLoca?.add_product?.length > 0 && type !== "edit"){
            let total = 0;

            paymentDataLoca?.add_product?.forEach(function(item,i){
                total = total + (item.price * item.qty * rentDay);

                if(paymentDataLoca?.add_product?.length - 1 === i){
                    setTotalAddTotalPrice(total);
                }
            });
        }
    }, []);

    useEffect(() => {
        if((card_no?.length === 19 || card_no?.length === 18)
            && exp_year?.length === 2
            && exp_month?.length === 2
            && (card_type == 1 ? birth?.length === 6 : birth?.length >= 12)
            && card_pw?.length === 2
            && is_chk === 1
        ){
            setCardBtnChk(false);
        }else{
            setCardBtnChk(true);
        }
    }, [card_type,card_no,exp_year,exp_month,birth,card_pw,is_chk]);

    useEffect(() => {
        let total = 0;
        let salePrice = 0;
        let carPrice = Number(totalAddTotalPrice) +
        Number(type === "edit" ? ((paymentDataLoca?.reservationData || (paymentDataLoca?.start_date && paymentDataLoca?.end_date)) && carData ? carData?.discount_price ? carData?.discount_price : carData?.original_price : reservationData?.original_price)
        : (carData?.discount_price ? carData?.discount_price : carData?.original_price));

        let point = Number(paymentData?.use_point);

        salePrice = Number(salePrice);

        if(paymentData?.coupon){
            let couponCri = carPrice;
            if(paymentData?.coupon?.discount_type === "price"){
                let couponPrice = (paymentData?.coupon?.use_condition === "max_price" && (paymentData?.coupon?.discount_value >= paymentData?.coupon?.use_condition_value) ? paymentData?.coupon?.use_condition_value : paymentData?.coupon?.discount_value);
                salePrice = Math.floor((Number(salePrice) + Number(couponPrice)) > carPrice ? carPrice : (Number(salePrice) + Number(couponPrice))||0);

                let saleSetTotal = Number(carPrice) - Number(salePrice);
                let saleSetTotal_floor = Math.floor(saleSetTotal / 100) * 100;
                let add_sale = saleSetTotal - Number(saleSetTotal_floor);

                salePrice = Number(salePrice) + (add_sale||0);

                let setCouponPrice = Number(couponPrice) + Number(add_sale);

                setTotalCouponPrice(Math.floor((setCouponPrice > carPrice ? carPrice : setCouponPrice)||0));
            }else{
                let couponValue = Number(couponCri) * (Number(paymentData?.coupon?.discount_value)/100);
                let couponPrice = paymentData?.coupon?.use_condition === "max_price" && (couponValue >= paymentData?.coupon?.use_condition_value) ? paymentData?.coupon?.use_condition_value : couponValue;
                salePrice = Math.floor((Number(salePrice) + Number(couponPrice)) > carPrice ? carPrice : (Number(salePrice) + Number(couponPrice))||0);

                let saleSetTotal = Number(carPrice) - Number(salePrice);
                let saleSetTotal_floor = Math.ceil(saleSetTotal / 100) * 100;
                let add_sale = saleSetTotal - Number(saleSetTotal_floor);

                salePrice = Number(salePrice) + (add_sale||0);

                let setCouponPrice = Number(couponPrice) + Number(add_sale);

                setTotalCouponPrice(Math.floor((setCouponPrice > carPrice ? carPrice : setCouponPrice)||0));
            }
        }

        total = Number(carPrice) - Number(salePrice);

        setMaxPoint(Math.min(total, total_point));

        if(point > total){
            point = total;

            paymentDataCh("use_point",point);
        }

        let totalSetPrice = (total - point) < 0 ? 0 : (total - point);

        setTotalSalePrice(salePrice + point);
        setTotalPrice(totalSetPrice);

        if((paymentData?.payment_method && (paymentData?.payment_method === "billing" ? paymentData?.user_card_id : true))|| totalSetPrice === 0){
            setBtnChk(false);
        }else{
            setBtnChk(true);
        }
    }, [paymentData]);

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                mBtn={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"결제 정보 입력"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={type === "edit" ? 1 : 0}
                    closeFunc={()=>{}}
                />
                <PageTitle
                    pageBack={()=>{navigate(-1)}}
                    contents="결제 정보 입력"
                />
                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarDetailItem
                            itemType=""
                            sectionTitle="기존 차량 정보"
                            titleAddClass="mItemT"
                            sectionCaptions={["차량 제원 및 옵션은 현장 사정에 따라 다른 옵션으로 구성된 차량이거나 동급차량으로 변경될 수 있습니다."]}
                            status={null}
                            car_image={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.image_url
                                 : reservationData?.image_url : carData?.image_url
                            }
                            maker={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.maker : reservationData?.maker
                                : carData?.maker
                            }
                            modelName={
                                type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.name : reservationData?.name
                                : carData?.name
                            }
                            passengerNum={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.passenger_number : reservationData?.passenger_number
                                : carData?.passenger_number
                            }
                            fuelType={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.fuel : reservationData?.fuel
                                : carData?.fuel
                            }
                            min_year={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.min_year : reservationData?.min_year 
                                : carData?.min_year
                            }
                            max_year={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.max_year : reservationData?.max_year
                                : carData?.max_year
                            }
                            car_option={type === "edit" ? 
                                carData ? carData?.options : reservationData?.options
                                : carData?.options
                            }
                            carOptionDisable={type === "edit" ? 
                                paymentDataLoca?.reservationData && carData ? carData?.non_options : reservationData?.non_options
                                : carData?.non_options
                            }
                            func={()=>{}}
                        />
                        {localStorage.getItem("token") ? 
                        <CarDetailSection 
                            captions={[]} 
                            title="할인"
                        >
                            <CarDetailTextArea title={null} addClass="">
                                <InputBoxCol2>
                                    <CustomSelect
                                        boxAddClass=""
                                        addClass="absoluteSel"
                                        inputName="쿠폰 선택"
                                        placeholder="쿠폰 선택"
                                        allData={true}
                                        valueText={paymentData?.coupon ? `${paymentData?.coupon?.name}(-${comFormat(paymentData?.coupon?.discount_value||"0")}${paymentData?.coupon?.discount_type === "percent" ? "%" : "원"})` : null}
                                        value={paymentData?.coupon?.id}
                                        func={(allData) => {
                                            paymentDataCh("coupon",allData)
                                        }}
                                        disabled={false}
                                        valKey="id"
                                        nameKey="name"
                                        options={couponItems}
                                    />
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="사용할 포인트 입력"
                                        placeholder="사용할 포인트 입력"
                                        value={paymentData?.use_point}
                                        max={null}
                                        regexp={"number"}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        maxNumber={(total_point >= maxPoint ? total_point : maxPoint)||0}
                                        readOnly={total_point ? false : true}
                                        func={(value)=>{paymentDataCh("use_point",value)}}
                                    />
                                </InputBoxCol2>
                                <InputCaption caption={`${comFormat(total_point||0)} 포인트 사용 가능`}/>
                            </CarDetailTextArea>
                        </CarDetailSection>
                        :""}
                        <CarDetailSection 
                            addClass={totalPrice <= 0 && settingChk ? "nonDisplay" : ""}
                            captions={null}
                            title="결제 수단"
                        >
                            <CarDetailTextArea>
                                <PaymentCardBtnBox
                                    id={"billing"}
                                    value={paymentData?.payment_method}
                                    func={(id)=>{
                                        paymentDataCh("payment_method",id);
                                    }}
                                    name={"+ 카드 간편결제"}
                                >
                                    <Swiper
                                        spaceBetween={20}
                                        slidesPerView={2}
                                        autoHeight={true}
                                        pagination={false}
                                        centeredSlides={true}
                                        onRealIndexChange={(e) => {
                                            if(cardApiData[e.activeIndex]){
                                                paymentDataCh("user_card_id",cardApiData[e.activeIndex]?.id)
                                            }else{
                                                paymentDataCh("user_card_id",null)
                                            }
                                        }}
                                        breakpoints={{
                                            1024: {
                                                spaceBetween:20,
                                                slidesPerView: 2
                                            },
                                            1: {
                                                spaceBetween:14,
                                                slidesPerView: 1.3
                                            }
                                        }}
                                    >
                                        {cardApiData && Array.isArray(cardApiData) && cardApiData?.map((item, i) => (
                                            <SwiperSlide key={i}>
                                                <CardItem
                                                    addClass=""
                                                    code={item.card_code}
                                                    name={item.name}
                                                    cardNumber={item.card_number}
                                                    cardDelFunc={()=>{
                                                        setPopupData({
                                                            addClass:null,
                                                            title:"카드 삭제",
                                                            text:"카드 정보를 삭제하시겠습니까?",
                                                            closeType:true,
                                                            closeFunc:(e) => {setPopupData(null)},
                                                            btnFunc0:(e)=>{setPopupData(null)},
                                                            btn0:"취소",
                                                            btn0Type:"subColor",
                                                            btn1:"확인",
                                                            btn1Type:"",
                                                            btnFunc1:()=>{setPopupData(null);cardDel(item.id)}
                                                        });
                                                    }}
                                                />
                                            </SwiperSlide>
                                        ))}
                                        <SwiperSlide>
                                            <CardAddBtn
                                                func={()=>{
                                                    setCardAddPopup({
                                                        addClass:"subTitle_line_2",
                                                        title:"카드 정보 등록",
                                                        subTitle:"한 번만 등록하시면<br/>빠르고 안전하게 결제가 가능해요",
                                                        closeType:true,
                                                        closeFunc:(e) => {setCardAddPopup(null)},
                                                        closePcOn:true
                                                    });
                                                }}
                                            />
                                        </SwiperSlide>
                                        <CardSlideControll/>
                                    </Swiper>
                                </PaymentCardBtnBox>
                                <PaymentTypeBtnBox>
                                    <PaymentTypeBtn
                                        id={"card"}
                                        value={paymentData?.payment_method}
                                        func={(id)=>{paymentDataCh("payment_method",id)}}
                                        name={"카드결제"}
                                    />
                                    {/* <PaymentTypeBtn
                                        id={"phone"}
                                        value={paymentData?.payment_method}
                                        func={(id)=>{paymentDataCh("payment_method",id)}}
                                        name={"휴대폰 결제"}
                                    /> */}
                                    <PaymentTypeBtn
                                        id={"naver"}
                                        value={paymentData?.payment_method}
                                        func={(id)=>{paymentDataCh("payment_method",id)}}
                                        name={`<img src="/assets/images/sns/naver_pay.svg"/>네이버페이`}
                                    />
                                    <PaymentTypeBtn
                                        id={"kakao"}
                                        value={paymentData?.payment_method}
                                        func={(id)=>{paymentDataCh("payment_method",id)}}
                                        name={`<img src="/assets/images/sns/kakao_pay.svg"/>카카오페이`}
                                    />
                                </PaymentTypeBtnBox>
                            </CarDetailTextArea>
                        </CarDetailSection>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <CarDetailControllBox
                            addClass={"nonFixed titleColor"}
                            title={"결제 정보"}
                            subTitle={
                                type === "edit" ? 
                                paymentDataLoca?.start_date && paymentDataLoca?.end_date ? 
                                    `${paymentDataLoca?.start_date && paymentDataLoca?.end_date ? getDateGap(paymentDataLoca?.start_date,paymentDataLoca?.end_date,"time",null) : "-"}시간`
                                    : `${reservationData?.start_date && reservationData?.end_date ? getDateGap(reservationData?.start_date,reservationData?.end_date,"time",null) : "-"}시간`
                                : paymentDataLoca?.start_date && paymentDataLoca?.end_date ? `총 ${getDateGap(paymentDataLoca?.start_date,paymentDataLoca?.end_date,"time",null)} 시간` : null
                            }
                        >
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={`차량 대여요금 ${(type === "edit" && (paymentDataLoca?.insurance_name || reservationData?.insurance_name)) || insuranceSel ? "(자차보험 포함)" : ""}`}
                                titleText={type === "edit" ? 
                                    `${comFormat(((paymentDataLoca?.reservationData || (paymentDataLoca?.start_date && paymentDataLoca?.end_date)) && carData ? carData?.discount_price ? carData?.discount_price : carData?.original_price : reservationData?.original_price)||"0")} 원`
                                    : `${comFormat((carData?.discount_price ? carData?.discount_price : carData?.original_price)||"0")} 원`
                                }
                            >
                                <CarSetInfoItem
                                    addClass=""
                                    name="예약 시간"
                                    text={
                                        type === "edit" ? 
                                        paymentDataLoca?.start_date && paymentDataLoca?.end_date ? 
                                            `${paymentDataLoca?.start_date && paymentDataLoca?.end_date ? getDateGap(paymentDataLoca?.start_date,paymentDataLoca?.end_date,"time",null) : "-"}시간`
                                            : `${reservationData?.start_date && reservationData?.end_date ? getDateGap(reservationData?.start_date,reservationData?.end_date,"time",null) : "-"}시간`
                                        : paymentDataLoca?.start_date && paymentDataLoca?.end_date ? `${getDateGap(paymentDataLoca?.start_date,paymentDataLoca?.end_date,"time",null)} 시간` : null
                                    }
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name="보험 정보"
                                    text={(type === "edit" ? 
                                        paymentDataLoca?.reservationData && carData ? paymentDataLoca?.insurance_name : reservationData?.insurance_name
                                        : insuranceSel?.name)||"-"
                                    }
                                />
                            </CarSetInfoSlideSection>
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={`할인 적용`}
                                titleText={`${totalSalePrice > 0 ? "- " : ""}${comFormat(totalSalePrice)} 원`}
                            >
                                {paymentData?.coupon ? 
                                    <CarSetInfoItem
                                        addClass=""
                                        name={`${paymentData?.coupon?.name}(${paymentData?.coupon?.discount_value ? "-" : ""}${comFormat(paymentData?.coupon?.discount_value||"0")}${paymentData?.coupon?.discount_type === "percent" ? "%" : "원"})`}
                                        text={`${totalCouponPrice > 0 ? "- " : ""}${comFormat(totalCouponPrice||"0")}${comFormat(totalCouponPrice) ? " 원" : ""}`}
                                    />
                                :""}

                                <CarSetInfoItem
                                    addClass=""
                                    name="포인트 사용"
                                    text={`${paymentData?.use_point > 0 ? "- " : ""}${comFormat(paymentData?.use_point||0)} 원`}
                                />
                            </CarSetInfoSlideSection>
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={"부가서비스"}
                                titleText={`${comFormat(totalAddTotalPrice)} 원`}
                            >
                                {type === "edit" ? 
                                    <>
                                        {paymentDataLoca?.add_product?.length > 0 || paymentDataLoca?.add_productChk ? 
                                            <>
                                                {paymentDataLoca?.add_product && paymentDataLoca?.add_product?.map((item,i)=>(
                                                    <CarSetInfoItem
                                                        key={i}
                                                        addClass=""
                                                        name={`${item.name} * ${item.qty}`}
                                                        text={`${comFormat((item.price * item.qty * (rentDayPayment ? rentDayPayment : rentDay))||"0")} 원`}
                                                    />
                                                ))}
                                            </>
                                        : reservationData?.add_products ? 
                                            <>
                                                {reservationData?.add_products?.map((item,i)=>(
                                                    <CarSetInfoItem
                                                        key={i}
                                                        addClass=""
                                                        name={`${item.name} * ${item.amount}`}
                                                        text={`${comFormat((Math.floor((item.price / item.amount / rentDay)||0) * item.amount * (rentDayPayment ? rentDayPayment : rentDay))||"0")} 원`}
                                                    />
                                                ))}
                                            </>
                                        :""}
                                    </>
                                    : <>
                                        {paymentDataLoca?.add_product?.length > 0 ? 
                                        <>
                                            {paymentDataLoca?.add_product && paymentDataLoca?.add_product?.map((item,i)=>(
                                                <CarSetInfoItem
                                                    key={i}
                                                    addClass=""
                                                    name={`${item.name} * ${item.qty}`}
                                                    text={`${comFormat((item.price * item.qty * rentDay)||"0")} 원`}
                                                />
                                            ))}
                                        </>
                                        :""}
                                    </>
                                }
                            </CarSetInfoSlideSection>
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={"대여/반납일시"}
                                titleText={null}
                            >
                                <CarSetInfoItem
                                    key={0}
                                    addClass=""
                                    name={"대여일시"}
                                    text={type === "edit" ? paymentDataLoca?.start_date ? paymentDataLoca?.start_date : reservationData?.start_date : paymentDataLoca?.start_date}
                                />

                                <CarSetInfoItem
                                    key={1}
                                    addClass=""
                                    name={"반납일시"}
                                    text={type === "edit" ? paymentDataLoca?.end_date ? paymentDataLoca?.end_date : reservationData?.end_date : paymentDataLoca?.end_date}
                                />
                            </CarSetInfoSlideSection>
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="bSize"
                                    name="총 결제 금액"
                                    text={`<span class='wbTextColor'>${comFormat(totalPrice)} 원</span>`}
                                />
                                {type === "edit" ? 
                                <CarSetInfoItem
                                    addClass="mSizeg"
                                    name="이전 결제 건 환불 금액"
                                    text={`${reservationData?.payment_price > 0 ? "- " : ""}${comFormat(reservationData?.payment_price||"0")} 원`}
                                />
                                :""}
                                <CarSetTermsItem
                                    addClass=""
                                    name="개인정보 수집/이용 동의"
                                    btnFunc={()=>{window.termsPopupOpen("privacy","개인정보 수집/이용 동의")}}
                                />
                                <CarSetTermsItem
                                    addClass=""
                                    name="개인정보 제3자 제공 동의"
                                    btnFunc={()=>{window.termsPopupOpen("privacy_supply","개인정보 제3자 제공 동의")}}
                                />
                                <CarSetTermsItem
                                    addClass=""
                                    name="결제대행 서비스 이용약관 동의"
                                    btnFunc={()=>{window.termsPopupOpen("payment","결제대행 서비스 이용약관 동의")}}
                                />
                            </CarSetInfoSection>
                            <CarSetInfoCaption
                                captions={[
                                    "위 내용을 모두 확인했으며, 결제에 동의합니다."
                                ]}
                                btn={null}
                                func={()=>{}}
                            />
                            <BtnBox
                                boxType=""
                                addClass={"row2_re mCol2 mFixed"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                                <BtnItem
                                    addClass=""
                                    disabled={btnChk}
                                    contents={`${comFormat(totalPrice)} 원 결제하기<img src="/assets/images/basic/filter_btn_move.svg"/>`}
                                    func={() => {
                                        paymentFunc();
                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <CustomPopup data={cardAddPopup}>
                <PopupContentsTitle title="카드 종류"/>
                <ChkSelect
                    addClass="row2"
                    title={null}
                    val={card_type}
                    data={[
                        {
                            id:"1",
                            category:"개인"
                        },
                        {
                            id:"2",
                            category:"법인"
                        }
                    ]}
                    func={(id)=>{
                        setCard_type(id);
                        setBirth(null);
                    }}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="카드 번호"
                    placeholder="“-”를 제외한 15~16자리 입력"
                    cardNumberSetting={true}
                    value={card_no}
                    max={19}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setCard_no(value)}}
                />
                <InputBoxCol2>
                    <InputItemBox
                        inputType={null}
                        addClass=""
                        inputName="카드 유효기간 (월)"
                        placeholder="MM"
                        value={exp_month}
                        max={2}
                        regexp={"number"}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        func={(value)=>{setExp_month(value)}}
                    />
                    <InputItemBox
                        inputType={null}
                        addClass=""
                        inputName="카드 유효기간 (년)"
                        placeholder="YY"
                        value={exp_year}
                        max={2}
                        regexp={"number"}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        func={(value)=>{setExp_year(value)}}
                    />
                </InputBoxCol2>
                <InputItemBox
                    inputType="password"
                    addClass=""
                    inputName="카드 비밀번호"
                    placeholder="비밀번호 앞 2자리"
                    value={card_pw}
                    max={2}
                    regexp={null}
                    func={(value)=>{setCard_pw(value)}}
                />
                
                {card_type == 1 ? 
                    <InputItemBox
                        inputType={null}
                        addClass=""
                        inputName="생년월일"
                        placeholder="YYMMDD"
                        value={birth}
                        max={6}
                        regexp={"number"}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        func={(value)=>{setBirth(value)}}
                    />
                    :
                    <InputItemBox
                        inputType={null}
                        addClass=""
                        inputName="사업자등록번호"
                        placeholder="사업자등록번호 10자리 입력"
                        value={birth}
                        businessNumberSetting={true}
                        max={12}
                        regexp={"number"}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        func={(value)=>{setBirth(value)}}
                    />
                }
                <ChkBox
                    addClass=""
                    func={(e) => setIs_chk(e.target.checked ? 1 : 0)}
                    checkedType={is_chk === 1 ? true : false}
                    label={`[필수] 결제대행 서비스 약관 동의`}
                    chkFunc={()=>{window.termsPopupOpen("payment","결제대행 서비스 이용약관 동의")}}
                />
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"취소"}
                        func={() => {
                            setCardAddPopup(null);
                            cardDataReset();
                        }}
                    />
                    <BtnItem
                        addClass=""
                        contents={"카드 등록"}
                        disabled={cardBtnChk}
                        func={() => {
                            cardAdd();
                        }}
                    />
                </BtnBox>
            </CustomPopup>    
            <Popup
                data={popupData}
            />         
            <Popup
                data={paymentFailedData}
            >
                <BaiscPopupTextBox
                    title={"결제 실패 사유"}
                    text={paymentFailedData?.alert}
                />
            </Popup>
            <Footer pcOnly={true}/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default RentPayment;